import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getBoardOfDirectorsList } from "../../networkCalls";
import CloseIcon from "@mui/icons-material/Close";
import FotterMain from "../BaseComponents/FotterMain";
import Header from "../BaseComponents/Header";
import LoadingCellFullPage from "../LoadingCell/LoadingCellFullPage";
import parse from "html-react-parser";
import { Accordion, Modal } from "react-bootstrap";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import { Accordion, AccordionDetails, AccordionSummary, IconButton, Typography } from "@mui/material";
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const BoardOfDirectorsListing = () => {
  const [loading, setLoading] = useState(false);
  const [resultData, setResultData] = React.useState([]);
  const [modal, setmodal] = useState(false);
  const [modalData, setModalData] = useState({});

  const handleCloseSocial = () => {
    setmodal(false);
  };
  const pullPressReleaseApi = () => {
    setLoading(true);
    getBoardOfDirectorsList().then((res) => {
      setLoading(false);
      switch (res.data.status) {
        case 1:
          console.log(res.data);
          setResultData(res?.data?.DirectorsList);
          //setErrMessage('');
          return true;
        case 0:
          //setErrMessage(res.data.msz);
          break;
        default:
          return;
      }
    });
  };

  useEffect(() => {
    pullPressReleaseApi();
  }, []);
  const toTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    toTop();
  }, []);
  const handleModal = (data) => {
    setmodal(true);
    setModalData(data);
  };
  return (
    <>
      <Header />
      {loading ? (
        <>
          <LoadingCellFullPage />
        </>
      ) : (
        <>
          <div className="innerpagebg pt-5 pb-5">
            <div className="container mb-4">
              <div className="row">
                <div className="col-12  m-auto">
                  <div className="align-items-center text-center">
                    <h4 className="d-inline-block m-0 fw-bold text-uppercase">
                      <span className="txtred">Board</span>{" "}
                      <span className="txtdgray">of Directors</span>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="container ">
              {resultData && resultData?.length > 0 ? (
                <>
                  <div className="row mx-2 px-2 lg-mx-5 lg-px-5">
                    {resultData &&
                      resultData?.map((data, index) => (
                        <div key={data?.dataId} className="col-lg-3 col-12">
                          <div className="post-card mb-4 position-relative hover-effect">
                            <div className="post-card__images position-relative overflow-hidden">
                              {/* Image */}
                              <img
                                alt=""
                                className="img-fluid w-100 zoom-effect"
                                src={data?.image}
                                onClick={() => handleModal(data)}
                              />

                              {/* Overlay */}
                              <div
                                className="overlay position-absolute bottom-0 start-0 w-100 d-flex justify-content-center align-items-center bg-danger bg-opacity-75 opacity-0 transition"
                                style={{
                                  transition: "opacity 0.3s",
                                  height: "40px",
                                  zIndex: 999,
                                }}
                                onClick={() => handleModal(data)}
                              >
                                <span className="text-white fw-bold">
                                  Read More
                                </span>
                              </div>
                            </div>

                            {/* Content */}
                            <div className="post-card__content text-center">
                              {/* <div className="hover-text pb-1"  onClick={() => handleModal(data)}> */}
                              <div style={{ height: "35px" }}>
                                <span
                                  className="txtred f16 fw-bold hover-text pb-1 "
                                  onClick={() => handleModal(data)}
                                >
                                  {data?.name}
                                </span>
                              </div>
                              {/* </div> */}
                              <div
                                className="post-card__title mb-0 mt-2"
                                style={{ height: "60px" }}
                              >
                                <p className="mb-1">
                                  <div
                                    onClick={() => handleModal(data)}
                                    className="txtdgray f-16 mb-0"
                                  >
                                    {data?.designation}
                                  </div>
                                </p>
                              </div>
                              <div className="" style={{ height: "30px" }}>
                                {data?.facebook !== null && (
                                  <Link
                                    to={data?.facebook}
                                    target="_blank"
                                    className="text-dark f16 me-1"
                                  >
                                    <FacebookIcon
                                      fontSize="medium"
                                      sx={{ color: "#1877F2" }}
                                    />
                                  </Link>
                                )}
                                {data?.instagram !== null && (
                                  <Link
                                    to={data?.instagram}
                                    target="_blank"
                                    className="text-dark f16 me-1"
                                  >
                                    <InstagramIcon
                                      fontSize="medium"
                                      sx={{ color: "#E4405F" }}
                                    />
                                  </Link>
                                )}
                                {data?.twitter !== null && (
                                  <Link
                                    to={data?.twitter}
                                    target="_blank"
                                    className="text-dark f16 me-1"
                                  >
                                    <XIcon
                                      fontSize="small"
                                      sx={{ color: "#000000" }}
                                    />
                                  </Link>
                                )}
                                {data?.linkedin !== null && (
                                  <Link
                                    to={data?.linkedin}
                                    target="_blank"
                                    className="text-dark f16 me-1"
                                  >
                                    <LinkedInIcon
                                      fontSize="medium"
                                      sx={{ color: "#0077B5" }}
                                    />
                                  </Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </>
              ) : (
                <>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="card text-center p-4">
                        No Records Found
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <Modal
            size="xl"
            show={modal}
            centered
            // backdrop="static"
            keyboard={false}
            contentClassName="border-0 rounded-0"
            onHide={() => handleCloseSocial()}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Body className="p-0">
              <div
                onClick={() => handleCloseSocial()}
                aria-label="delete"
                size="small"
                className="position-absolute top-0 end-0 btn-out"
              >
                <CloseIcon fontSize="small" className="text-white" />
              </div>
              <div className="bg-white  p-4">
                {/* <h3 className="post-header__title">{modalData?.name}</h3> */}
                <div className="row">
                  <div className="col-12 col-lg-3 col-md-3 flex flex-col text-center">
                    <img
                      alt=""
                      className="img-fluid   zoom-effect"
                      // width={100}
                      // height={100}
                      src={modalData?.image}
                      // onClick={() => handleModal(data)}
                    />
                    <p className="txtred f20 fw-bold mt-3 mb-2">
                      {modalData?.name}
                    </p>
                    <p className="txtdgray f14 fw-lighter mb-2">
                      {modalData?.designation}
                    </p>
                  </div>

                  <div className="col-12 col-lg-9 col-md-9">
                    {/* <div className="txtdgray f16 ">
                  {parse(`${modalData?.shortDesc}`)}
                </div> */}
                    <div className="txtdgray modal_description_text f14 ">
                      {parse(`${modalData?.longDesc}`)}
                    </div>
                  </div>
                  {modalData.tableDesc !== null && (
                    <div className=" col-12">
                      <Accordion>
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            <span className="fw-bold">
                              Directorship(s) of the directors and their
                              full-time positions in Body Corporates:
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            {/* {parse(`${modalData?.tableDesc}`)} */}
                            <div className="table-responsive_table">
                              {parse(`${modalData?.tableDesc}`)}
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  )}
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}

      <FotterMain />
    </>
  );
};

export default BoardOfDirectorsListing;
